import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";

import { Link, NeoColor, StackItem, Text } from "@noom/wax-component-library";

import { NeoButton } from "@/components";
import {
  QuestionComponentProps,
  QuestionDefinition,
} from "@/components/survey/Question";
import { useBWell, useGoto, useTrackEvent } from "@/hooks";
import { captureException } from "@/utils/sentry";

import { BaseInterstitial } from "../core";

const QUESTION_ID = "connectHealthRecordsPrivacy";

const ConnectHealthRecordsPrivacy: React.FC<QuestionComponentProps> = ({
  onClickBack,
  onClickNext,
}) => {
  const { isLoading, launchIdentityVerification } = useBWell();
  const goto = useGoto();
  const { trackIdentifiedPageViewed } = useTrackEvent();
  const { t } = useTranslation();

  useEffect(() => {
    trackIdentifiedPageViewed(QUESTION_ID);
  }, []);

  const beginVerification = async () => {
    try {
      await launchIdentityVerification();
    } catch (error) {
      captureException(error);
      goto.error();
    }
  };

  return (
    <BaseInterstitial
      headerText={t("connectHealthRecordsPrivacy.heading")}
      onClickBack={onClickBack}
      onClickNext={onClickNext}
      questionId={QUESTION_ID}
    >
      <Text>
        <Trans
          i18nKey="connectHealthRecordsPrivacy.body"
          components={[
            <Text key="prefix" as="span" />,
            <Link
              color={NeoColor.blue.lagoon}
              href="https://www.icanbwell.com/legal/privacy-and-security-statement/"
              isExternal
              key="link"
            />,
          ]}
        />
      </Text>
      <StackItem display="flex" justifyContent="center">
        <NeoButton
          onClick={() => beginVerification()}
          isLoading={isLoading}
          disabled={isLoading}
        >
          {t("connectHealthRecordsPrivacy.ctaText")}
        </NeoButton>
      </StackItem>
    </BaseInterstitial>
  );
};

export const Q_CONNECT_HEALTH_RECORDS_PRIVACY: QuestionDefinition = {
  id: QUESTION_ID,
  shouldShowQuestion: () => true,
  component: ConnectHealthRecordsPrivacy,
};
